import { useEffect, useState, useRef } from 'react'

type ChannelName = 'submission_review'
type MessageType = 'reviewed_submission'

const useBroadcastChannel = (channelName: ChannelName) => {
    const [message, setMessage] = useState<MessageType | null>(null)
    const channelRef = useRef<BroadcastChannel | null>(null)

    useEffect(() => {
        const channel = new BroadcastChannel(channelName)
        channelRef.current = channel

        const handleMessage = (event: MessageEvent) => {
            setMessage(event.data)
        }

        channel.addEventListener('message', handleMessage)

        return () => {
            // Remove the event listener to prevent memory leaks.
            channel.removeEventListener('message', handleMessage)
            channel.close()
            channelRef.current = null
        }
    }, [channelName])

    const postMessage = (msg: MessageType) => {
        if (channelRef.current) {
            channelRef.current.postMessage(msg)
        }
    }

    return { message, postMessage, reset: () => setMessage(null) }
}

export default useBroadcastChannel
